import React from "react";
import ArticleSearchContainer from "../../../containers/ArticleSearchContainer";
import { countHits, handleChangeIds } from "../../../../utils/checkBoxFunc";
import { NAGOYA_WARD_OPTIONS } from "../common/portalSearch";

function PortalPCWardCheckboxList() {
  const { areaIds, setAreaIds, aggs } = ArticleSearchContainer.useContainer();
  const normalizedAreaIds = Array.isArray(areaIds) ? areaIds : [];
  const onChange = handleChangeIds(normalizedAreaIds, setAreaIds);

  return (
    <ul className="portalPcCheckList">
      {NAGOYA_WARD_OPTIONS.map((opt) => {
        const id = `portal-pc-modal-ward-${opt.value}`;
        return (
          <li key={opt.value}>
            <label htmlFor={id}>
              <input
                id={id}
                type="checkbox"
                value={opt.value}
                checked={normalizedAreaIds.includes(opt.value)}
                onChange={onChange}
              />
              <span className="portalPcCheckLabel">
                {opt.label}({countHits(aggs.area_count.area.buckets, opt.value)}
                件)
              </span>
            </label>
          </li>
        );
      })}
    </ul>
  );
}

export default PortalPCWardCheckboxList;
